// TODO: Needs to fix detection of removing in handleChangeSubscribers
import React, { useState } from 'react';
import { Input } from 'antd';
import clsx from 'clsx';
import ConfirmationDownloadCentered from 'src/components/common/ConfirmationDownloadCentered';
import { EmailSubscriptionItem } from './EmailSubscriptionItem';
import styles from './EmailSubscription.module.less';

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

type PropsEmailSubscription = {
  subscriptions: string[];
  placeholder?: string;
  setSubscribers: (subscriptions: string[]) => void;
};

const warningMessage = 'Warning: The email subscription will be deleted. Are you sure you want to continue?';

export const EmailSubscription: React.FC<PropsEmailSubscription> = ({
  subscriptions,
  placeholder = 'Enter email',
  setSubscribers,
}) => {
  const [email, setEmail] = useState<string>('');
  const [removedEmail, setRemovedEmail] = useState<string>('');
  const isValidEmail = email ? emailRegex.test(email) : true;

  const handleAddSubscriber = (email: string) => {
    if (email && isValidEmail) {
      const newSubscriptions = [...subscriptions, email].sort();
      setSubscribers([...new Set(newSubscriptions)]);
      setEmail('');
    }
  };

  const handleRemoveSubscriber = () => {
    if (removedEmail) {
      setSubscribers(subscriptions.filter((item) => item !== removedEmail));
    }
    setRemovedEmail('');
    setEmail('');
  };

  return (
    <>
      <Input
        className={clsx(styles.emailInput, !isValidEmail && styles.invalid)}
        value={email}
        placeholder={placeholder}
        onChange={(e) => setEmail(e.target.value)}
        onPressEnter={(e) => handleAddSubscriber(e.currentTarget.value)}
      />

      {subscriptions.length > 0 && (
        <div className={clsx(styles.subscriptions, 'ant-select-selection')}>
          {subscriptions.map((item) => {
            return <EmailSubscriptionItem key={item} email={item} onRemove={() => setRemovedEmail(item)} />;
          })}
        </div>
      )}
      <ConfirmationDownloadCentered
        title={'Confirm deleting the email subscription'}
        name={''}
        confirmationVisible={!!removedEmail}
        notCloseOnConfirm={true}
        onAction={() => handleRemoveSubscriber()}
        setVisible={() => setRemovedEmail('')}
        message={warningMessage}
      />
    </>
  );
};
